import Vue, { RenderContext } from 'vue';

export const props = {
    bodyClass: {
        type: [String, Object, Array],
        default: null
    }
};

export const TCardBody = Vue.extend({
    name: 'TCardBody',
    functional: true,
    props,
    render(h: any, { props, children }: RenderContext) {
        return h(
            'div',
            {
                class: [props.bodyClass, {}],
                staticClass: 'card-body'
            },
            children
        );
    }
});
